import { groupBy, orderBy } from 'lodash-es';

import { MobileIssueTypeCount } from 'src/common/types/MobileSingleSessionTypes';

import { MfaSessionIssueTypesQuery } from '../MfaSessionIssueTypes.generated';

export const transformMfaSessionIssueTypesResults = (
	rawResults: MfaSessionIssueTypesQuery
): MobileIssueTypeCount[] => {
	const issues = rawResults.issues || [];
	const totalIssues = issues.length;
	const groupedByType = groupBy(issues, (issue) => issue.type_name);

	// Transform groups into MobileIssueTypeCount objects and sort by count (descending)
	return orderBy(
		Object.values(groupedByType).map((issueGroup) => {
			const firstIssue = issueGroup[0];
			return {
				type: firstIssue.type_name,
				count: issueGroup.length,
				totalIssues,
				severity: firstIssue.severity_name,
				scanName: firstIssue.scan_name
			};
		}),
		['count'],
		['desc']
	);
};
